import angular from 'angular';

class ModalDeleteInvitedEntityCtrl {
    /*@ngInject*/
    constructor(invitedEntitySvc, logger) {
        this.invitedEntitySvc = invitedEntitySvc;
        this.logger = logger;
    }

    deleteInvitedEntity() {
        let vm = this;
        this.invitedEntitySvc.deleteInvitedEntity(vm.resolve.invitedEntity.id).then(
            function (data) {
                vm.logger.success('success.delete', data, null, {
                    entityName: vm.resolve.invitedEntity.legalEntity.name,
                });
                vm.modalInstance.close();
            },
            function () {
                vm.logger.error('error.delete');
                vm.cancel();
            }
        );
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}

angular.module('app.principal').component('modalDeleteInvitedEntity', {
    templateUrl: require('./modal-delete-invited-entity.html'),
    controller: ModalDeleteInvitedEntityCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
